module.exports = __webpack_public_path__ + "img/background-event.f46972e5.png";